import CIcon from '@coreui/icons-react'
import { cilBolt, cilMemory, cilPeople, cilSpeedometer, cilAvTimer } from '@coreui/icons'
import type { OverviewResponse } from '../../api/types'
import { formatDateTime, formatMemory, formatNumber, formatPercent } from '../../utils/format'
import { StatusPill } from '../common/StatusPill'

export function MachineStateCard({ overview }: { overview: OverviewResponse }) {
  const current = overview.current
  return (
    <article className="machine-card">
      <div className="machine-card__identity">
        <span className="eyebrow">Current machine state</span>
        <div className="machine-card__title">
          <h2>{overview.machine.displayName}</h2>
          <StatusPill state={overview.machine.state} pulse={overview.machine.telemetryFresh} />
        </div>
        <p>
          {current?.workloadLabel
            ? current.workloadLabel
            : current?.projectAlias
              ? `Supporting public project ${current.projectAlias}`
              : overview.machine.state === 'ready'
                ? 'Healthy capacity is available for approved research.'
                : 'Public operating context is shown without exposing private commands or identities.'}
        </p>
        <div className="machine-card__updated">
          <CIcon icon={cilAvTimer} />{' '}
          {overview.machine.lastSeenAt
            ? `Last observed ${formatDateTime(overview.machine.lastSeenAt)}`
            : 'No observed telemetry has arrived'}
          {!overview.machine.telemetryFresh && <strong> · not live</strong>}
        </div>
      </div>
      <div className="machine-card__metrics">
        <div>
          <CIcon icon={cilSpeedometer} />
          <span>GPU activity</span>
          <strong>{formatPercent(current?.gpuUtilizationPct, 0)}</strong>
        </div>
        <div>
          <CIcon icon={cilMemory} />
          <span>Memory used</span>
          <strong>{formatMemory(current?.memoryUsedMiB)}</strong>
        </div>
        <div>
          <CIcon icon={cilBolt} />
          <span>Power</span>
          <strong>{current?.powerW == null ? '—' : `${formatNumber(current.powerW)} W`}</strong>
        </div>
        <div>
          <CIcon icon={cilPeople} />
          <span>Processes / services</span>
          <strong>{current ? `${current.activeProcessCount} / ${current.serviceCount}` : '—'}</strong>
        </div>
      </div>
    </article>
  )
}
